import { render } from "./home.vue?vue&type=template&id=7071c961&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=7071c961&lang=scss&scoped=true"

import exportComponent from "/var/www/pc-coupons/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7071c961"]])

export default __exports__